import { useEffect, useState } from "react";

/** Session key for the stays map on/off, shared by the hub and the type pages. */
const STAYS_MAP_KEY = "mj-stays-map";

/**
 * The stays map toggle, off by default and remembered for the visit, so Back
 * from a hotel returns to the map the guest left.
 *
 * Read after mount: the server cannot see sessionStorage, and reading it
 * during render would make the first paint disagree with the server's.
 */
export function useRememberedMap(): [boolean, (next: boolean) => void] {
  const [on, setOn] = useState(false);
  useEffect(() => {
    try {
      if (window.sessionStorage.getItem(STAYS_MAP_KEY) === "1") setOn(true);
    } catch {
      /* Storage blocked (private mode): the map simply starts off. */
    }
  }, []);
  const set = (next: boolean) => {
    setOn(next);
    try {
      window.sessionStorage.setItem(STAYS_MAP_KEY, next ? "1" : "0");
    } catch {
      /* Storage blocked: the choice lasts until the page is left. */
    }
  };
  return [on, set];
}
